/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const OrangeLem: any = (props: {}) => {
  return (
    <svg width="96" height="162" viewBox="0 0 96 162" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.345 50.5792C63.9264 50.5792 87.6 69.5008 87.6 102.206C87.6 132.518 62.87 153.834 31.345 153.834C-1.5396 153.834 -23.2942 132.682 -24.9223 99.1132C-26.3342 69.9095 -8.7406 19.1442 47.8673 0L50.6968 5.57614C35.6875 15.8435 24.072 31.9615 22.5308 42.2739C21.0983 51.865 28.7541 50.5792 31.345 50.5792"
        fill="#EF452F"
      />
      <path
        d="M49.9018 74.1482C50.7687 70.104 51.6367 66.0552 52.5062 62H94.2725C88.0875 83.4646 80.9474 104.251 73.7824 125.111C69.7198 136.938 65.6491 148.789 61.74 160.8H31.2407C37.567 131.688 43.7095 103.034 49.9018 74.1482Z"
        stroke="#66371F"
        strokeWidth="2"
      />
    </svg>
  );
};

export default OrangeLem;
